// src/Dashboard/pages/user/PrepaPhysique/PrepaPhysiqueDashboard.jsx

import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../../../hooks/useScollToTop";

import { useUserPrepaPhysique } from "./hooks/useUserPrepaPhysique";

import PrepaPhysiqueHeader from "./components/PrepaPhysiqueHeader";
import PrepaPhysiqueKpiCards from "./components/PrepaPhysiqueKpiCards";
import PrepaPhysiqueAdherentSelector from "./components/PrepaPhysiqueAdherentSelector";
import PrepaPhysiqueFilters from "./components/PrepaPhysiqueFilters";
import PrepaPhysiqueExerciseTable from "./components/PrepaPhysiqueExerciseTable";
import PrepaPhysiqueExerciseMobileCards from "./components/PrepaPhysiqueExerciseMobileCards";
import PrepaPhysiqueEmptyState from "./components/PrepaPhysiqueEmptyState";
import PrepaPhysiqueImageModal from "./components/PrepaPhysiqueImageModal";

export default function PrepaPhysiqueUserDashboard() {
  useScrollToTop();

  const {
    loading,
    savingKey,

    adherents,
    selectedAdherentId,
    setSelectedAdherentId,
    selectedAdherent,

    exercises,
    filteredExercises,

    filters,
    setFilters,
    programmes,

    stats,

    imagePreview,
    openImagePreview,
    closeImagePreview,

    handleToggleDone,
    resetFilters,
    refresh,
  } = useUserPrepaPhysique();

  return (
    <section className="w-full pb-10 pt-5 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5 px-3 sm:px-4 lg:px-6">
        <PrepaPhysiqueHeader loading={loading} onRefresh={refresh} />

        <PrepaPhysiqueKpiCards stats={stats} loading={loading} />

        <PrepaPhysiqueAdherentSelector
          adherents={adherents}
          selectedAdherentId={selectedAdherentId}
          setSelectedAdherentId={setSelectedAdherentId}
          exercisesBySelectedCount={exercises.length}
          loading={loading}
        />

        <section className="overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
          <div className="h-1.5 bg-gradient-to-r from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

          <div className="p-4 sm:p-5 lg:p-6">
            <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
              <div>
                <p className="text-[11px] uppercase tracking-[0.22em] text-slate-500 dark:text-slate-400">
                  Préparation physique
                </p>

                <h2 className="mt-1 text-xl font-bold text-slate-900 dark:text-white">
                  Mes exercices à réaliser
                </h2>

                <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300">
                  Consultez les exercices assignés par vos enseignants,
                  visualisez les répétitions prévues, ouvrez les vidéos et
                  cochez les exercices une fois réalisés.
                </p>
              </div>

              <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm dark:border-slate-700 dark:bg-slate-800/60">
                <span className="text-slate-500 dark:text-slate-400">
                  Affichés :
                </span>{" "}
                <span className="font-bold text-slate-900 dark:text-white">
                  {filteredExercises.length}
                </span>
                <span className="text-slate-500 dark:text-slate-400">
                  {" "}
                  / {exercises.length}
                </span>
              </div>
            </div>

            <div className="mt-5">
              <PrepaPhysiqueFilters
                filters={filters}
                setFilters={setFilters}
                programmes={programmes}
                loading={loading}
                onReset={resetFilters}
              />
            </div>

            {loading ? (
              <div className="mt-5 space-y-3">
                {[...Array(5)].map((_, index) => (
                  <div
                    key={index}
                    className="h-24 animate-pulse rounded-2xl border border-slate-200 bg-slate-50 dark:border-slate-800 dark:bg-slate-800/60"
                  />
                ))}
              </div>
            ) : adherents.length === 0 ? (
              <PrepaPhysiqueEmptyState
                title="Aucun adhérent rattaché"
                description="Aucun adhérent n’est actuellement associé à votre compte utilisateur."
              />
            ) : exercises.length === 0 ? (
              <PrepaPhysiqueEmptyState
                title="Aucun exercice assigné"
                description={
                  selectedAdherent
                    ? `Aucun exercice de préparation physique n’est assigné à ${selectedAdherent.prenom || ""}.`
                    : "Aucun exercice de préparation physique n’est assigné."
                }
              />
            ) : filteredExercises.length === 0 ? (
              <PrepaPhysiqueEmptyState
                title="Aucun résultat"
                description="Aucun exercice ne correspond aux filtres sélectionnés."
                onReset={resetFilters}
              />
            ) : (
              <div className="mt-5">
                <PrepaPhysiqueExerciseTable
                  exercises={filteredExercises}
                  adherentId={selectedAdherentId}
                  savingKey={savingKey}
                  onToggleDone={handleToggleDone}
                  onOpenImage={openImagePreview}
                />

                <PrepaPhysiqueExerciseMobileCards
                  exercises={filteredExercises}
                  adherentId={selectedAdherentId}
                  savingKey={savingKey}
                  onToggleDone={handleToggleDone}
                  onOpenImage={openImagePreview}
                />
              </div>
            )}
          </div>
        </section>
      </div>

      <PrepaPhysiqueImageModal
        image={imagePreview}
        onClose={closeImagePreview}
      />

      <ToastContainer />
    </section>
  );
}